import { Sites } from '@ps/platform-message-framework/common/Sites';
import { StarsButton, Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { CasinoRace } from '@swf/core/types/CasinoRaces';
import { Status } from '@swf/core/types/CasinoRaces';
import { isRunning } from '@swf/core/utils/casino';

import {
  TXTCLI_Cancelled,
  TXTCLI_Finished,
  TXTCLI_Play,
  TXTCLI_Register__toTournament,
  TXTCLI_Registered,
  TXTWCL_Join
} from './PlayButton.messages.json';
import styles from './PlayButton.scss';

export interface Props {
  race: CasinoRace;
  onLeaderboard?(): void;
  onLaunch(): void;
}

const PlayButton: React.FC<Props> = ({ race, onLeaderboard, onLaunch }) => {
  const { status, userRaceStanding } = race;
  const running = isRunning(status);
  const size = !onLeaderboard ? 'large' : 'small';
  const siteId = useSelector(select.cms.getSiteId);

  if (running) {
    return (
      <StarsButton
        className={styles.playbarButton}
        size={size}
        onClick={onLaunch}
        translation={siteId === Sites.GR ? TXTWCL_Join : TXTCLI_Play}
      />
    );
  } else if (status === Status.CANCELLED) {
    return (
      <span className={styles.finished}>
        <Translation {...TXTCLI_Cancelled} />
      </span>
    );
  } else if (status === Status.COMPLETED) {
    return (
      <span className={styles.finished}>
        <Translation {...TXTCLI_Finished} />
      </span>
    );
  } else if (userRaceStanding) {
    return (
      <span className={styles.register}>
        <Translation {...TXTCLI_Registered} />
      </span>
    );
  } else {
    return (
      <StarsButton
        size={size}
        onClick={onLaunch}
        variant="casino"
        inverse
        translation={TXTCLI_Register__toTournament}
      />
    );
  }
};

export default PlayButton;
